// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  EMAIL_INVALID_DOMAIN:
    'This email is ineligible. Please enter an eligible email.',
  EMAIL_INVALID_ERROR:
    "Uh oh! It looks like this email address isn't valid. Can you double-check?",
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_EMAIL_FIELD',
  MESSAGES
)
